/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Role_FailedInputs */

const en_endpoint_role_failed = /** @type {(inputs: Endpoint_Role_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed`)
};

const zh_hans1_endpoint_role_failed = /** @type {(inputs: Endpoint_Role_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`失败`)
};

const pt_br2_endpoint_role_failed = /** @type {(inputs: Endpoint_Role_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falhou`)
};

const es_endpoint_role_failed = /** @type {(inputs: Endpoint_Role_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falló`)
};

const fr_endpoint_role_failed = /** @type {(inputs: Endpoint_Role_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec`)
};

const de_endpoint_role_failed = /** @type {(inputs: Endpoint_Role_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehlgeschlagen`)
};

const ru_endpoint_role_failed = /** @type {(inputs: Endpoint_Role_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не ответил`)
};

const it_endpoint_role_failed = /** @type {(inputs: Endpoint_Role_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fallito`)
};

/**
* | output |
* | --- |
* | "Failed" |
*
* @param {Endpoint_Role_FailedInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_role_failed = /** @type {((inputs?: Endpoint_Role_FailedInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Role_FailedInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_role_failed(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_role_failed(inputs)
	if (locale === "es") return es_endpoint_role_failed(inputs)
	if (locale === "fr") return fr_endpoint_role_failed(inputs)
	if (locale === "de") return de_endpoint_role_failed(inputs)
	if (locale === "ru") return ru_endpoint_role_failed(inputs)
	if (locale === "it") return it_endpoint_role_failed(inputs)
	return en_endpoint_role_failed(inputs)
});